import { Maybe } from '../definition';
import { Environment, FeatureFlagsConfig } from './types';

export function getEnvironment(): Environment {
  const stage = import.meta.env.VITE_APP_STAGE;
  return stage;
}

export function isFeatureEnabled(
  config: Maybe<FeatureFlagsConfig>,
  feature: Maybe<string>
): boolean {
  if (!config) return false;
  if (!feature) return true;
  if (typeof config[feature] === 'boolean') return config[feature];
  const environment = getEnvironment();
  if (config[feature] === 'stg') return environment !== 'prod';
  if (config[feature] === 'dev') return environment === 'dev';
  if (config[feature] === 'prod') return true;
  return typeof config[feature] === 'undefined';
}
